/**
 * Export Options Configuration
 *
 * This file combines all export option groups from separate category modules
 */

import { mostPopularGroup } from '@/features/data-hub/constants/mostPopular';
import type { ExportOption, ExportOptionGroup } from '@/features/data-hub/types/exportConfig.types';

import { biPlatformsGroup } from './biPlatforms';
import { cloudPlatformsGroup } from './cloudPlatforms';
import { integrationsGroup } from './integrations';

export const exportOptionsGroups: ExportOptionGroup[] = [
  mostPopularGroup,
  cloudPlatformsGroup,
  biPlatformsGroup,
  integrationsGroup
] as const;

type WithGroup = ExportOption & { groupName: string };

export const optionById: ReadonlyMap<string, Readonly<WithGroup>> = (() => {
  const m = new Map<string, WithGroup>();
  for (const g of exportOptionsGroups) {
    for (const o of g.options) {
      m.set(o.id, Object.freeze({ ...o, groupName: g.groupName }));
    }
  }
  return m;
})();
